import { render, staticRenderFns } from "./EntitlementsManager.vue?vue&type=template&id=2e9fb204&scoped=true"
import script from "./EntitlementsManager.vue?vue&type=script&lang=js"
export * from "./EntitlementsManager.vue?vue&type=script&lang=js"
import style0 from "./EntitlementsManager.vue?vue&type=style&index=0&id=2e9fb204&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9fb204",
  null
  
)

export default component.exports